(function () {
  if (window.__ga4CartListenerActive) return;
  window.__ga4CartListenerActive = true;

  function getProductData(variantId) {
    var script = document.querySelector('[data-product-data][data-variant-id="' + variantId + '"]');
    if (!script) return null;
    try { return JSON.parse(script.textContent); }
    catch (e) { return null; }
  }

  function pushEvent(eventName, variantId, quantity) {
    var d = getProductData(variantId);
    if (!d) return;
    var finalPrice = d.price;
    var discount   = Math.max(0, (d.compare_at_price || d.price) - finalPrice);
    var qty        = quantity || 1;
    var gtm        = window.GTMData || {};
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: eventName,
      store_country:  gtm.store_country || "",
      store_language: gtm.store_language || "",
      ecommerce: {
        currency: d.currency,
        value:    finalPrice * qty,
        items: [{
          item_name:  d.title,
          item_id:    d.sku || String(variantId),
          price:      finalPrice,
          item_brand: d.vendor,
          quantity:   qty,
          discount:   discount
        }]
      }
    });
  }

  document.addEventListener("click", function (e) {
    var plusBtn = e.target.closest(".plusAddToCartMiniCart");
    if (plusBtn && plusBtn.dataset.variantId) {
      pushEvent("add_to_cart", plusBtn.dataset.variantId, 1);
      return;
    }
    var minusBtn = e.target.closest(".minusRemoveFromMiniCart");
    if (minusBtn && minusBtn.dataset.variantId) {
      pushEvent("remove_from_cart", minusBtn.dataset.variantId, 1);
      return;
    }
    var removeBtn = e.target.closest(".cart-item__remove-btn");
    if (removeBtn && removeBtn.dataset.variantId) {
      var qty = parseInt(removeBtn.dataset.itemQuantity, 10) || 1;
      pushEvent("remove_from_cart", removeBtn.dataset.variantId, qty);
      return;
    }

    // Card prodotto — ATC da quick view / list view
    var cardAtcBtn = e.target.closest('form[data-type="add-to-cart-form"] button[name="add"]');
    if (cardAtcBtn && !cardAtcBtn.closest('#CartDrawer') && !cardAtcBtn.closest('#main-cart-items') && !cardAtcBtn.closest('[id^="x-product-template-"]')) {
      var form = cardAtcBtn.closest('form[data-type="add-to-cart-form"]');
      if (form) {
        var variantInput = form.querySelector('input[name="id"]');
        if (variantInput) {
          var variantId = variantInput.value;
          var qtyInput = form.querySelector('input[name="quantity"]');
          var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
          pushEvent('add_to_cart', variantId, qty);
        }
      }
      return;
    }

  }, true);
})();